module.exports = __webpack_public_path__ + "media/2.f603f8f9.mp3";